export const LANGUAGE_CONSTANTS = {
  en: {
    VALIDATION_ERRORS: {
      EMAIL_UNVALID: "Email is not valid",
      PASSWORD_UNVALID: "Password is not valid",
      NAME_UNVALID: "Please enter proper name",
    },
    LABELS: {
      SIGN_UP: "Sign Up",
      SIGN_IN: "Sign In",
      SIGN_UP_NOW: 'Sign up now.',
      SIGN_OUT: "Sign Out",
      GPT_SEARCH: "GPT Search",
      BROWSE_MOVIES: "Browse Movies",
      SEARCH: "Search",
      SEARCH_PLACEHOLDER: 'What would you like to see?',
      NEW_TO_CINEGPT : "New to CineGPT.",
      ALREADY_HAVE_AN_ACCOUNT: "Already have an account?",
      FULL_NAME_PLACEHOLDER: "Full Name",
      EMAIL_PLACEHOLDER: "Email",
      PASSWORD_PLACEHOLDER: "Password",
      PLAY: "Play",
      MORE_INFO:"More Info"
    },
    MOVIE_TITLES: {
      NOW_PLAYING_MOVIES: "Now Playing Movies",
      TOP_RATED_MOVIES: "Top Rated Movies",
      POPULAR_MOVIES: "Popular Movies",
      UPCOMING_MOVIES: "Upcoming Movies"
    }
  },
  hi: {
    VALIDATION_ERRORS: {
      EMAIL_UNVALID: "ईमेल मान्य नहीं है",
      PASSWORD_UNVALID: "पासवर्ड मान्य नहीं है",
      NAME_UNVALID: "कृपया सही नाम दर्ज करें",
    },
    LABELS: {
      SIGN_UP: "साइन अप करें",
      SIGN_IN: "साइन इन करें",
      SIGN_UP_NOW: "अभी साइन अप करें।",
      SIGN_OUT: "साइन आउट",
      GPT_SEARCH: "GPT खोज",
      BROWSE_MOVIES: "फिल्में देखें",
      SEARCH: "खोजें",
      SEARCH_PLACEHOLDER: "आप क्या देखना चाहेंगे?",
      NEW_TO_CINEGPT: "CineGPT पर नए हैं।",
      ALREADY_HAVE_AN_ACCOUNT: "पहले से खाता है?",
      FULL_NAME_PLACEHOLDER: "पूरा नाम",
      EMAIL_PLACEHOLDER: "ईमेल",
      PASSWORD_PLACEHOLDER: "पासवर्ड",
      PLAY: "चलाएं",
      MORE_INFO: "अधिक जानकारी",
    },
    MOVIE_TITLES: {
      NOW_PLAYING_MOVIES: "अब चल रही फिल्में",
      TOP_RATED_MOVIES: "सर्वश्रेष्ठ रेटेड फिल्में",
      POPULAR_MOVIES: "लोकप्रिय फिल्में",
      UPCOMING_MOVIES: "आगामी फिल्में",
    },
  },
  mr: {
    VALIDATION_ERRORS: {
      EMAIL_UNVALID: "ईमेल वैध नाही",
      PASSWORD_UNVALID: "पासवर्ड वैध नाही",
      NAME_UNVALID: "कृपया योग्य नाव टाका",
    },
    LABELS: {
      SIGN_UP: "साइन अप करा",
      SIGN_IN: "साइन इन करा",
      SIGN_UP_NOW: "आत्ता साइन अप करा.",
      SIGN_OUT: "साइन आउट",
      GPT_SEARCH: "GPT शोध",
      BROWSE_MOVIES: "चित्रपट ब्राउझ करा",
      SEARCH: "शोधा",
      SEARCH_PLACEHOLDER: "तुम्हाला काय पाहायचं आहे?",
      NEW_TO_CINEGPT: "CineGPT वर नवीन आहात.",
      ALREADY_HAVE_AN_ACCOUNT: "आधीच खाते आहे?",
      FULL_NAME_PLACEHOLDER: "पूर्ण नाव",
      EMAIL_PLACEHOLDER: "ईमेल",
      PASSWORD_PLACEHOLDER: "पासवर्ड",
      PLAY: "प्ले करा",
      MORE_INFO: "अधिक माहिती",
    },
    MOVIE_TITLES: {
      NOW_PLAYING_MOVIES: "आत्ता चालू असलेले चित्रपट",
      TOP_RATED_MOVIES: "सर्वोत्तम रेट केलेले चित्रपट",
      POPULAR_MOVIES: "लोकप्रिय चित्रपट",
      UPCOMING_MOVIES: "आगामी चित्रपट",
    },
  },
  es: {
    VALIDATION_ERRORS: {
      EMAIL_UNVALID: "El correo electrónico no es válido",
      PASSWORD_UNVALID: "La contraseña no es válida",
      NAME_UNVALID: "Por favor, introduce un nombre válido",
    },
    LABELS: {
      SIGN_UP: "Registrarse",
      SIGN_IN: "Iniciar sesión",
      SIGN_UP_NOW: "Regístrate ahora.",
      SIGN_OUT: "Cerrar sesión",
      GPT_SEARCH: "Búsqueda GPT",
      BROWSE_MOVIES: "Explorar películas",
      SEARCH: "Buscar",
      SEARCH_PLACEHOLDER: "¿Qué te gustaría ver?",
      NEW_TO_CINEGPT: "¿Nuevo en CineGPT?",
      ALREADY_HAVE_AN_ACCOUNT: "¿Ya tienes una cuenta?",
      FULL_NAME_PLACEHOLDER: "Nombre completo",
      EMAIL_PLACEHOLDER: "Correo electrónico",
      PASSWORD_PLACEHOLDER: "Contraseña",
      PLAY: "Reproducir",
      MORE_INFO: "Más información",
    },
    MOVIE_TITLES: {
      NOW_PLAYING_MOVIES: "Películas en cartelera",
      TOP_RATED_MOVIES: "Películas mejor valoradas",
      POPULAR_MOVIES: "Películas populares",
      UPCOMING_MOVIES: "Próximas películas",
    },
  },
  fr: {
    VALIDATION_ERRORS: {
      EMAIL_UNVALID: "L'e-mail n'est pas valide",
      PASSWORD_UNVALID: "Le mot de passe n'est pas valide",
      NAME_UNVALID: "Veuillez entrer un nom correct",
    },
    LABELS: {
      SIGN_UP: "S'inscrire",
      SIGN_IN: "Se connecter",
      SIGN_UP_NOW: "Inscrivez-vous maintenant.",
      SIGN_OUT: "Se déconnecter",
      GPT_SEARCH: "Recherche GPT",
      BROWSE_MOVIES: "Parcourir les films",
      SEARCH: "Rechercher",
      SEARCH_PLACEHOLDER: "Que voulez-vous voir ?",
      NEW_TO_CINEGPT: "Nouveau sur CineGPT.",
      ALREADY_HAVE_AN_ACCOUNT: "Vous avez déjà un compte ?",
      FULL_NAME_PLACEHOLDER: "Nom complet",
      EMAIL_PLACEHOLDER: "E-mail",
      PASSWORD_PLACEHOLDER: "Mot de passe",
      PLAY: "Lire",
      MORE_INFO: "Plus d'infos",
    },
    MOVIE_TITLES: {
      NOW_PLAYING_MOVIES: "Films à l'affiche",
      TOP_RATED_MOVIES: "Films les mieux notés",
      POPULAR_MOVIES: "Films populaires",
      UPCOMING_MOVIES: "Films à venir",
    },
  }
};

export default LANGUAGE_CONSTANTS
